import {createBrowserHistory} from "history";
import AdminLayout from "layouts/AdminNew.js";
import React from "react";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import PrivateRoute from "util/common/PrivateRoute";
import AuthLayout from "layouts/Auth.js";
import useAutoLogout from "./util/hooks/useAutoLogout";
import {cerrarSession, isLogin} from "./util/common/Common";

const hist = createBrowserHistory();

// minutos de inactividad antes de cerrar sesión (configurable por .env)
const INACTIVITY_MINUTES = Number(process.env.REACT_APP_AUTOLOGOUT_MINUTES || '15');
const INACTIVITY_TIMEOUT_MS = INACTIVITY_MINUTES * 60 * 1000;

function App() {

    const logout = (reason) => {
        // sólo cerrar sesión si el usuario está logueado y no está en rutas de autenticación (/auth)
        try {
            const path = window.location.pathname || '';
            if (isLogin() && !path.startsWith('/auth')) {
                cerrarSession(reason || 'manual');
            }
        } catch (e) {
            // fallback: no hacer nada
            console.error('Error en logout auto:', e);
        }
    };

    useAutoLogout(logout, INACTIVITY_TIMEOUT_MS);

    return (
    <Router history={hist} basename={process.env.REACT_APP_ROUTER_BASE || ""}>
      <Switch>
          <Route path="/auth" component={AuthLayout} />
          <PrivateRoute path="/admin" component={AdminLayout} />
          <Redirect from="/" to="/auth/login-page" />
      </Switch>
    </Router>
  );
}

export default App;
